import axios from 'axios';
import { isLoggedIn, getToken, setToken } from '@/helpers/authentication';
import sanitizeFilename from 'sanitize-filename';
import { saveAs } from 'file-saver';

const api = axios.create({
  baseURL: '/api',
});

api.interceptors.request.use((config) => {
  if (isLoggedIn()) {
    // eslint-disable-next-line no-param-reassign
    config.headers.Authorization = `JWT ${getToken()}`;
  }
  return config;
});

export async function login(username, password) {
  const response = await api.post('/login', { username, password });
  setToken(response.data.token);
}

export function downloadFile(blob, filename) {
  saveAs(blob, sanitizeFilename(filename));
}

export default api;
